import { defaultBlock } from './fragments/defaultBlock'

const ttLocationsQuery = /* groq */ `
{
  "ttLocations": *[_type == "ttLocation"] | order(_updatedAt desc) {
	  name,
  	hideOnMap,
  	number,
  	street,
  	suburb,
  	postcode,
  	geocoord,
    "slug": slug.current,
    "lat": geocoord.lat,
    "long": geocoord.lng,
		locationCopy,
		locationLink
	}
}`

const vantagePointsQuery = /* groq */ `
{
  "vantagePoints": *[_type == "location" && vantagePoints == true] | order(_updatedAt desc) {
	  name,
    hideOnMap,
    number,
    street,
    suburb,
    postcode,
    geocoord,
    "slug": slug.current,
    "lat": geocoord.lat,
    "long": geocoord.lng,
    directionsLink
	}
}`

export { ttLocationsQuery, vantagePointsQuery }
